import { Button } from 'antd';
import TextWinds from '../../../common/TextWinds';
import { AssignmentTab } from './StudentAssignmentPanel';
import { ChartBarIcon, ListBulletIcon } from '@heroicons/react/24/outline';

interface StudentAssignmentTabsProps {
  selectedTab: AssignmentTab;
  onTabChange: (tab: AssignmentTab) => void;
}

/**
 * 개편 LMS (학생) - 클래스 상세 페이지 > 콘텐츠 판넬 > 우측 탭
 */
const StudentAssignmentTabs = ({
  selectedTab,
  onTabChange,
}: StudentAssignmentTabsProps) => {
  const tabs = [
    {
      label: '과제 목록',
      value: 'ASSIGNMENT_LIST' as AssignmentTab,
      icon: ListBulletIcon,
    },
    {
      label: '진도 지도',
      value: 'PROGRESS_MAP' as AssignmentTab,
      icon: ChartBarIcon,
    },
  ];

  return (
    <div className="rounded-xl bg-gray0 p-2">
      <div className="grid grid-cols-2 gap-2">
        {tabs.map((tab) => {
          const isSelected = selectedTab === tab.value;
          const Icon = tab.icon;

          return (
            <Button
              key={tab.value}
              type="text"
              className={[
                'flex h-12 items-center justify-center gap-2 rounded-lg',
                isSelected
                  ? '!border !border-gray3 !bg-white !shadow-sm'
                  : '!bg-transparent hover:!bg-white/60',
              ].join(' ')}
              onClick={() => onTabChange(tab.value)}
            >
              <Icon className={'h-5 w-5 text-gray7'} />

              <TextWinds
                type="content_body2"
                color="gray8"
                className={'font-bold'}
              >
                {tab.label}
              </TextWinds>
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default StudentAssignmentTabs;
